import { render } from "./TargetEdit.vue?vue&type=template&id=77ff11aa&scoped=true"
import script from "./TargetEdit.vue?vue&type=script&lang=js"
export * from "./TargetEdit.vue?vue&type=script&lang=js"

import "./TargetEdit.vue?vue&type=style&index=0&id=77ff11aa&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ff11aa"]])

export default __exports__